import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const headers: Readonly<Record<string, string | boolean>> = {
  Accept: 'application/json',
  'Content-Type': 'application/json; charset=utf-8'
};

const getApiBaseUrl = () => {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    //Platform
    if (hostname.includes('platform.partsol.ai')) {
      return 'https://platform.partsol.ai/catalog/api/v1/';
    }
    //Dev
    else if (hostname.includes('dev.partsol.ai')) {
      return 'https://dev.partsol.ai/catalog/api/v1';
    }
  }
  return process.env.REACT_APP_API_BASE_URL;
};

const checkmateApi: AxiosInstance = axios.create({
  baseURL: getApiBaseUrl(),
  headers,
  withCredentials: false
});

let authInterceptor = checkmateApi.interceptors.request.use(
  (config: AxiosRequestConfig): AxiosRequestConfig => {
    return config;
  }
);

export const attachAuthInterceptor = (token: string) => {
  checkmateApi.interceptors.request.eject(authInterceptor);
  authInterceptor = checkmateApi.interceptors.request.use(
    (config: AxiosRequestConfig): AxiosRequestConfig => {
      if (token) {
        return { ...config, headers: { ...config.headers, Authorization: `Bearer ${token}` } };
      }
      return { ...config, headers: { ...config.headers } };
    }
  );
};

export const ejectAuthInterceptor = () => {
  checkmateApi.interceptors.request.eject(authInterceptor);
}

export default checkmateApi;
